import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import dayjs from "dayjs";

import { InboundLayout,InboundHeaderCard } from "ui-components/Layout";
import { InboundSubmitButton, InboundDetailEditButton } from "ui-components/Form";

import { headerRender, headerValues, headerValidation } from "./co-receiving-schema";
import { detailRender, detailValues, detailValidation } from "./co-receiving-details-schema";
import { useCustomerValue } from "providers/CustomerContext";
import { Success, Error_ } from "ui-components/Alert";
import { InfoDialog } from "ui-components/Alert";
import { useMutation, useQuery } from "@tanstack/react-query";
import { createCOReceiving } from "services/data.inbound.service";
import { getCOOptions } from "services/data.inbound.service";
import COReceiving from "./components/COReceiving";
import COReceivingDetail from "./components/COReceivingDetail";
import { coRecvColumns, coRecvViewColumns } from "./columns";
import BasicTable2 from "ui-components/tables/BasicTable2";
import { getOpenCO,getVDONoForCO,getOpenCOByVDONo } from "services/data.inbound.service";
import { statusLabel } from "layouts/views/common/enum";
import ApplyAll from "../components/ApplyAll";
import { LoadingDialog } from "ui-components/Alert";
import { CORecvCaption } from "../components/Caption";
import {
  deleteDetail,
  getSplitDetailsTotalQuantity,
  getTotalQuantity,
  updateDetail,
} from "../common/common";
import { useVendorOptionsWithName } from "hooks/useQueryHook";
import { useNavigate } from "react-router-dom";
import BasicViewTable from "ui-components/tables/BasicViewTable";

const defaultValues = {
  ...headerValues,
  dateReceived: dayjs(new Date()).format("YYYY-MM-DD"),
  status: "Open",
  recvType: "Consignee Return Receipt (Trade Return)",
};
function AddCOReceiving() {
  const { customerCode } = useCustomerValue();
  const navigate = useNavigate();
  const [vendorOptions, setVendorOptions] = useState([]);
  const [formValues, setFormValues] = useState({ ...defaultValues, customerCode });
  const [alert, setAlert] = useState(null);
  const [details, setDetails] = useState([]);
  const [notScannedDetails, setNotScannedDetails] = useState([]);
  const [coOptions, setCOOptions] = useState([]);
  const [vDONoOptions, setVDONoOtpions] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createCOReceivingMutation = useMutation(createCOReceiving, {});
  //console.log("createCOReceivingMutation");
  useVendorOptionsWithName({
    customerCode,
    onSuccess: (data) => {
      const vendors = data.data.data;
      //console.log("useVendorOptionsWithName");
      if (vendors.length > 0) {
        setValue("vendorCode", vendors[0].vendorCode);
        setValue("sellerCompany", vendors[0].vendShortName);
      }
      setVendorOptions(
        vendors.map((x) => x.vendorCode)
      );
    },
  });

  const form = useForm({
    defaultValues: formValues,
    values: formValues,
    resolver: yupResolver(headerValidation),
  });
  const {
    control,
    watch,
    formState: { errors, isSubmitting, isSubmitted },
    handleSubmit,
    setValue,
    getValues,
    trigger,
  } = form;
  const headerProps = {
    headerRender,
    customerCode,
    coOptions,
    vendorOptions,
    control,
    setValue,
    errors,
    vDONoOptions,
  };

  const [collectionOrderNo, vendorCode] = watch(["collectionOrderNo", "vendorCode"]);
  useQuery({
    queryKey: ["co-options", { customerCode }],
    queryFn: () => getCOOptions({ customerCode }),
    enabled: customerCode !== null && vendorCode !== null,
    onSuccess: (data) => setCOOptions(data.data.data),
    onError,
  });
  const { isFetching } = useQuery({
    queryKey: ["co", { collectionOrderNo }],
    queryFn: () => getOpenCO({ coNumber: collectionOrderNo }),
    enabled: collectionOrderNo !== null && customerCode !== null && vendorCode !== null,
    onSuccess: (data) => {
      //console.log(data);
      const {
        coDetails,
        notScannedCODetails,
        truckNo,
        sellerCompany,
        sellerAddress1,
        sellerAddress2,
        sellerPostcode,
        sellerCity,
        sellerState,
        sellerCountry,
        sellerPhoneNo,
        sellerFaxNo,
        remark,
      } = data.data.data;
      setValue("sellerCompany", sellerCompany);
      setValue("sellerAddress1", sellerAddress1);
      setValue("sellerAddress2", sellerAddress2);
      setValue("sellerPostcode", sellerPostcode);
      setValue("sellerCity", sellerCity);
      setValue("sellerState", sellerState);
      setValue("sellerCountry", sellerCountry);
      setValue("sellerPhoneNo", sellerPhoneNo);
      setValue("sellerFaxNo", sellerFaxNo);
      setValue("truckNo", truckNo);
      setValue("remark", remark);
      //setFormValues({ ...formValues, collectionOrderNo, ...headerData });
      setDetails(coDetails.map((detail) => ({ ...detail, status: statusLabel[detail.status] })));
      setNotScannedDetails(notScannedCODetails)
    },
    onError,
  });
  const detailProps = { details, setDetails,notScannedDetails, values: { customerCode, vendorCode } };
  const [vDONo] = watch(["vDONo"]);
  useQuery({
    queryKey: ["vdono", vendorCode],
    queryFn: () => getVDONoForCO({ vendorCode }),
    enabled: Boolean(customerCode) && Boolean(vendorCode),
    onSuccess: (data) => setVDONoOtpions(data.data.data),
    onError,
  });

   const { isFetching: isFetchingVDONo } = useQuery({
    queryKey: ["vDONo", { vDONo }],
    //queryFn: () => getOpenCOByVDONo({ vdono: vDONo }),
    queryFn: () => {
  //console.log("🔥 getOpenCOByVDONo is running with:", vDONo);
  return getOpenCOByVDONo({ vDONo: vDONo,customerCode });
},
    enabled: vDONo !== null && customerCode !== null && vendorCode !== null,
    onSuccess: (data) => {
      //console.log(data);
      const {
        coDetails,
        notScannedCODetails,
        truckNo,
        sellerCompany,
        sellerAddress1,
        sellerAddress2,
        sellerPostcode,
        sellerCity,
        sellerState,
        sellerCountry,
        sellerPhoneNo,
        sellerFaxNo,
        remark,
      } = data.data.data;
      setValue("sellerCompany", sellerCompany);
      setValue("sellerAddress1", sellerAddress1);
      setValue("sellerAddress2", sellerAddress2);
      setValue("sellerPostcode", sellerPostcode);
      setValue("sellerCity", sellerCity);
      setValue("sellerState", sellerState);
      setValue("sellerCountry", sellerCountry);
      setValue("sellerPhoneNo", sellerPhoneNo);
      setValue("sellerFaxNo", sellerFaxNo);
      setValue("truckNo", truckNo);
      setValue("remark", remark);
      //setFormValues({ ...formValues, collectionOrderNo, ...headerData });
      setDetails(coDetails.map((detail) => ({ ...detail, status: statusLabel[detail.status],
         skuCode: detail.skuCode || "",
    recvLocation: detail.recvLocation || "",
    qtyReceived: detail.qtyReceived ?? 0,
    qtyExpected: detail.qtyExpected ?? 0,
    coLineNo: detail.coLineNo ?? 1,
    currencyCode: detail.currencyCode ?? "MYR",
    customsLot: detail.customsLot ?? null,
    expiryDateCtrl: detail.expiryDateCtrl ?? false,
    lineNo:detail.lineNo ?? 1,
    manDateCtrl: detail.manDateCtrl ??false,
    manualLot: detail.manualLot ?? null,
    manualLotCtrl: detail.manualLotCtrl ?? false,
    mlnCtrl:detail.mlnCtrl ?? false,
    oln:detail.oln ?? null,
    packType:detail.packType ?? "01",
    recvWh: detail.recvWh || "",
    recvZone: detail.recvZone || "",
    // recvWh:"SNTWHSE",
    // recvZone:"SNT-RETURN",
    remark:detail.remark || null,
    returnCode:detail.returnCode ?? null,
       })));
      setNotScannedDetails(notScannedCODetails)
    },
    onError,
  });

  const onSubmit = async () => {
    //console.log("submit");
    window.scrollTo(0, 0);
    const isValid = await trigger();
    if (!isValid) return;

    if (details.length === 0) {
      setAlert(<Error_ content="Invalid CO Receiving Details" onChange={setAlert} />);
      return;
    }
    //console.log("after first checking");
    const data = getValues();

    const req = { ...data, collectionOrderNo: collectionOrderNo ?? vDONo
    ,  coRecvDetails: details.map((d) => ({ ...d, status: "O" }))
   };
    //console.log("after req");
    createCOReceivingMutation.mutate(req, {
      onSuccess: (data) => navigate("/inbound/co-receiving", { state: data.data.message }),
      onError,
    });
  };
  return (
    <InboundLayout lg={12}>
      {isFetching && isFetchingVDONo && <LoadingDialog />}
      {alert}
      <InboundHeaderCard>
        <form noValidate>
          <COReceiving {...headerProps} />
        </form>
      </InboundHeaderCard>

      <Detail {...detailProps} />
      <InboundSubmitButton
        label="Submit"
        onClick={handleSubmit(onSubmit)}
        disabled={isSubmitting}
      />
    </InboundLayout>
  );
}

const Detail = ({ details, setDetails,notScannedDetails, values }) => {
  const columns = [
    {
      field: "actions",
      headerName: "Action",
      renderActions: ["Add", "Delete"],
      type: "actions",
    },
    ...coRecvColumns,
  ];
  const [alert, setAlert] = useState(null);

  const [formValues, setFormValues] = useState(null);
  const [dialog, setDialog] = useState(null);
  const lineNo = formValues ? formValues.lineNo : details.length + 1;

  const form = useForm({
    defaultValues: { ...detailValues, lineNo },
    values: formValues || {
      ...detailValues,
      lineNo,
      status: "",
    },
    resolver: yupResolver(detailValidation),
  });
  const {
    control,
    watch,
    formState: { errors, isDirty },
    setValue,
    getValues,
    handleSubmit,
  } = form;
  const [skuCode, qtyReceived, recvWh, recvZone] = watch([
    "skuCode",
    "qtyReceived",
    "recvWh",
    "recvZone",
  ]);

  const onSubmit = (data) => {
    setDetails(updateDetail(details, data));
    setFormValues(null);
    setAlert(<Success content="Updated" onChange={setAlert} />);
  };
  const onRowClick = (values) => {
    if (formValues !== null && isDirty) {
      setDialog(
        <InfoDialog
          title={`Unsaved changes for Line No ${formValues.lineNo}`}
          content="Do you want to save the changes"
          onOk={() => {
            const data = getValues();
            setDetails(updateDetail(details, data));
            setDialog(null);
            setFormValues(values);
          }}
          onClose={() => {
            setDialog(null);
            setFormValues(values);
          }}
        />
      );
    } else {
      setFormValues(values);
    }
    return true;
  };
  const handleDelete = (data) => {
    setDetails(deleteDetail(details, data));
    setFormValues(null);
    setAlert(<Success content="Deleted" onChange={setAlert} />);
  };
  const onAdd = (data) => {
    const newLine = { ...data, lineNo: data.lineNo + 1 };
    const updatedDetail = [
      ...details.slice(0, data.lineNo),
      newLine,
      ...details.slice(data.lineNo, details.length + 1)
    ]
    for (let i = data.lineNo + 1; i < updatedDetail.length ; i++) {
      updatedDetail[i].lineNo += 1;
    }
    setDetails(updatedDetail);
    // setDetails([...details, { ...data, lineNo: details.length + 1 }]);
    setAlert(<Success content="Added" onChange={setAlert} />);
  };

  const detailProps = {
    detailRender,
    values: { ...values, skuCode, qtyReceived, recvWh, recvZone },
    control,
    errors,
    setValue,
    getValues,
  };
  const totalQuantity = getTotalQuantity(details, "quantity");
  const totalExpectedQuantity = getSplitDetailsTotalQuantity(details, "qtyExpected", "coLineNo");
  const Caption = (
    <CORecvCaption
      totalRows={details.length}
      totalQuantity={totalQuantity}
      totalExpectedQuantity={totalExpectedQuantity}
    />
  );
  const applyAllProps = { formValues, setFormValues,setValue, details, setDetails };
  return (
    <InboundHeaderCard>
      {alert}
      <ApplyAll {...applyAllProps} />
       
      {dialog}

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <COReceivingDetail {...detailProps} />
        {formValues !== null && (
          <InboundDetailEditButton disabled={!isDirty} onClick={() => setFormValues(null)} />
        )}
      </form>

      <BasicTable2
        columns={columns}
        rows={details}
        caption={Caption}
        onDelete={handleDelete}
        onAdd={onAdd}
        onRowClick={onRowClick}
      />
      {notScannedDetails.length > 0 && (
        <div style={{ marginTop: "1rem" }}>
          <BasicViewTable title="Datagrid Display (CO details not scanned)" rows={notScannedDetails} columns={coRecvViewColumns} />
        </div>
      )}
    </InboundHeaderCard>
  );
};

export default AddCOReceiving;
